import React from "react";
import { withRouter } from "react-router-dom";

import { testLocator } from "@/lib/helpers/test-locator";

import { CloseIcon } from "../../Icons/CloseIcon";
import { EditIcon } from "../../Icons/EditIcon";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { ICON_SIZES, ICON_TYPES } from "../../../constants/icons";
import { PrinterIcon } from "../../Icons/PrinterIcon";
import { TrashCanIcon } from "../../Icons/TrashCanIcon";

import "./styles.scss";

const NoteActions = (props) => {
  const {
    isEditable,
    isEditing,
    note,
    patientId,
    setDraftNoteId,
    setIsEditing,
    setShowDeleteNotePopUp,
  } = props;

  return (
    <div className="NoteActions--wrapper tw:print:hidden">
      {isEditable && !isEditing && (
        <>
          <div
            alt="edit"
            className="NoteActions--icon_button"
            onClick={() => {
              if (note?.note_type === "Care Management") {
                setIsEditing(true);

                return;
              }

              const showV2 = note?.version && note?.version === 2;

              props.history.push(
                `/app/patient/${patientId}/note/${note.id}/${showV2 ? "v2/" : ""}draft`,
              );
            }}
            {...getAutomationDataAttr("note-actions-edit-button")}
            {...testLocator("noteEditBtn")}
          >
            <EditIcon
              className="NoteActions--edit_icon"
              iconSize={ICON_SIZES.SMALL}
              iconType={ICON_TYPES.OUTLINE}
            />
            <p className="NoteActions--icon_text NoteActions--edit_text">Edit</p>
          </div>

          <div
            alt="print"
            className="NoteActions--icon_button"
            onClick={() => {
              props.history.push(`/app/patient/${patientId}/export_notes?noteIds=${note.id}`);
            }}
          >
            <PrinterIcon
              className="NoteActions--print_icon"
              iconSize={ICON_SIZES.SMALL}
              iconType={ICON_TYPES.OUTLINE}
            />
            <p className="NoteActions--icon_text NoteActions--print_text">Print</p>
          </div>

          <div
            alt="delete"
            className="NoteActions--icon_button"
            onClick={() => {
              setShowDeleteNotePopUp(true);
              setDraftNoteId(note.id);
            }}
            {...testLocator("noteDeleteBtn")}
          >
            <TrashCanIcon
              className="NoteActions--delete_icon"
              iconSize={ICON_SIZES.SMALL}
              iconType={ICON_TYPES.OUTLINE}
            />
            <p className="NoteActions--icon_text NoteActions--delete_text">Delete Draft</p>
          </div>
        </>
      )}

      {isEditing && (
        <div
          alt="discard changes"
          className="NoteActions--icon_button"
          onClick={() => {
            setIsEditing(false);
          }}
        >
          <CloseIcon
            className="NoteActions--discard_icon"
            iconSize={ICON_SIZES.SMALL}
            iconType={ICON_TYPES.OUTLINE}
          />
          <p className="NoteActions--icon_text NoteActions--discard_text">Discard Changes</p>
        </div>
      )}
    </div>
  );
};

export default withRouter(NoteActions);
